import { atom } from 'jotai';

export type AnnouncementColorType = 'info' | 'warning' | 'success' | 'error';
export type AnnouncementStatus = 'scheduled' | 'active' | 'expired';

export interface IAnnouncement {
    id?: number;
    title: string;
    message: string;
    color_type: AnnouncementColorType;
    start_date: string;
    end_date: string;
    created_by?: number;
    created_at?: string;
    updated_at?: string;
    status?: AnnouncementStatus;
}

export const announcementsAtom = atom<IAnnouncement[]>([]);
export const announcementsLoadingAtom = atom<boolean>(false);
export const activeAnnouncementAtom = atom<IAnnouncement | null>(null);
